import styled from 'styled-components';
import Button from 'shared/ui/Button';

export const MessageWrapper = styled.div`
  width: 450px;
  user-select: none;
`;

MessageWrapper.displayName = 'MessageWrapper';

export const StyledLink = styled(Button).attrs({ variant: 'link' })`
  padding: 0px;
`;

MessageWrapper.displayName = 'MessageWrapper';
